(function () {
  function getSection(container) {
    return container.closest('[data-mt-collection-filters]');
  }

  function formatMoney(cents) {
    var format = (typeof theme !== 'undefined' && theme.moneyFormat) || '${{amount}}';
    if (typeof theme !== 'undefined' && theme.Helpers && theme.Helpers.formatMoney) {
      return theme.Helpers.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function getShopCurrency(section) {
    if (section && section.dataset.shopCurrency) {
      return section.dataset.shopCurrency;
    }
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return '';
  }

  function refreshEtransMoney(section) {
    if (typeof etranslateCurrency !== 'function' || typeof metaFiles === 'undefined') return;

    var shopCode = getShopCurrency(section);
    var currentCode = localStorage.getItem('currentCurrency') || shopCode;
    var origin = null;
    var current = null;

    (metaFiles.user_currencies_data || []).forEach(function (data) {
      if (data.code === shopCode) origin = data;
      if (data.code === currentCode) current = data;
    });

    if (!origin || !current || origin.code === current.code) return;

    section.querySelectorAll('[data-mt-collection-card] .etrans-money').forEach(function (el) {
      el.removeAttribute('data-currency');
    });

    etranslateCurrency(origin, current);
  }

  function setMoneyContent(wrap, cents) {
    if (!wrap) return null;

    var moneyEl = wrap.querySelector('.etrans-money');
    if (!moneyEl) {
      moneyEl = document.createElement('span');
      moneyEl.className = 'etrans-money';
      wrap.textContent = '';
      wrap.appendChild(moneyEl);
    }

    moneyEl.textContent = formatMoney(cents);
    moneyEl.removeAttribute('data-currency');
    return moneyEl;
  }

  function updateSortDisplay(sortSelect) {
    if (!sortSelect || !sortSelect.options.length) return;

    const display = sortSelect
      .closest('.mt-collection-filters__sort-select-wrap')
      ?.querySelector('[data-mt-sort-display]');

    if (!display) return;

    const label = sortSelect.options[sortSelect.selectedIndex].text.trim();
    display.textContent = '(' + label + ')';
  }

  function updateMobileSortDisplay(section, label) {
    if (!section) return;

    const mobileDisplay = section.querySelector('[data-mt-mobile-sort-display]');
    if (mobileDisplay && label) {
      mobileDisplay.textContent = '(' + label + ')';
    }
  }

  function syncMobileSortState(section, sortValue) {
    if (!section) return;

    section.querySelectorAll('[data-mt-mobile-sort-option]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.sortValue === sortValue);
    });
  }

  function bindMobileControls(section) {
    if (!section || section.dataset.mtMobileControlsBound === 'true') return;

    const sidebar = section.querySelector('#sidebar');
    const backdrop = section.querySelector('[data-mt-filter-backdrop]');
    const openButtons = section.querySelectorAll('[data-mt-filter-open]');
    const closeButtons = section.querySelectorAll('.js-collection-side-close');

    if (!sidebar || !openButtons.length) return;

    section.dataset.mtMobileControlsBound = 'true';

    function openFilterModal() {
      sidebar.classList.add('open');
      if (backdrop) {
        backdrop.classList.add('is-visible');
        backdrop.setAttribute('aria-hidden', 'false');
      }
      document.body.classList.add('mt-collection-filters--modal-open');
    }

    function closeFilterModal() {
      sidebar.classList.remove('open');
      if (backdrop) {
        backdrop.classList.remove('is-visible');
        backdrop.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('mt-collection-filters--modal-open');
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openFilterModal();
      });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        closeFilterModal();
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeFilterModal);
    }

    section.querySelectorAll('[data-mt-mobile-sort-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const sortValue = btn.dataset.sortValue;
        const sortSelect = section.querySelector('[data-mt-collection-sort]');
        const mobileSort = section.querySelector('[data-mt-mobile-sort]');

        if (sortSelect) {
          sortSelect.value = sortValue;
          updateSortDisplay(sortSelect);
        }

        updateMobileSortDisplay(section, btn.textContent.trim());
        syncMobileSortState(section, sortValue);

        if (mobileSort) {
          mobileSort.open = false;
        }

        if (typeof theme === 'undefined' || !theme.CollectionFilters) return;

        const params = new URLSearchParams(window.location.search);
        params.delete('page');
        params.set('sort_by', sortValue);
        theme.CollectionFilters.renderPage(params.toString(), section);
      });
    });
  }

  function bindSort(section) {
    const sortSelect = section.querySelector('[data-mt-collection-sort]');
    if (!sortSelect || sortSelect.dataset.mtSortBound === 'true') return;

    sortSelect.dataset.mtSortBound = 'true';
    updateSortDisplay(sortSelect);
    updateMobileSortDisplay(section, sortSelect.options[sortSelect.selectedIndex].text.trim());
    syncMobileSortState(section, sortSelect.value);

    sortSelect.addEventListener('change', function () {
      updateSortDisplay(sortSelect);
      updateMobileSortDisplay(section, sortSelect.options[sortSelect.selectedIndex].text.trim());
      syncMobileSortState(section, sortSelect.value);

      if (typeof theme === 'undefined' || !theme.CollectionFilters) return;

      const params = new URLSearchParams(window.location.search);
      params.delete('page');
      params.set('sort_by', sortSelect.value);
      theme.CollectionFilters.renderPage(params.toString(), section);
    });
  }

  function bindActiveFilters(section) {
    if (typeof theme === 'undefined' || !theme.CollectionFilters || !theme.CollectionFilters.currentFilters) return;
    theme.CollectionFilters.currentFilters(section);
  }

  function setCardImage(img, src) {
    if (!img || !src) return;
    img.src = src;
    img.removeAttribute('srcset');
  }

  function getCardVariants(card) {
    const jsonEl = card.querySelector('[data-mt-card-variants]');
    if (!jsonEl) return [];
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return [];
    }
  }

  function getDefaultOptions(card) {
    if (!card.mtDefaultOptions) {
      const el = card.querySelector('[data-mt-card-default-options]');
      if (el) {
        try {
          card.mtDefaultOptions = JSON.parse(el.textContent);
        } catch (error) {
          card.mtDefaultOptions = [null, null, null];
        }
      } else {
        card.mtDefaultOptions = [null, null, null];
      }
    }
    return card.mtDefaultOptions;
  }

  function getSelectedOptions(card) {
    if (!card.mtSelectedOptions) {
      card.mtSelectedOptions = getDefaultOptions(card).slice();
    }
    return card.mtSelectedOptions;
  }

  function optionsMatchVariant(options, variant) {
    if (options[0] != null && variant.option1 !== options[0]) return false;
    if (options[1] != null && variant.option2 !== options[1]) return false;
    if (options[2] != null && variant.option3 !== options[2]) return false;
    return true;
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return optionsMatchVariant(options, variant);
    }) || null;
  }

  function syncSelectedWithVariant(selected, variant) {
    if (!variant) return selected;
    selected[0] = variant.option1;
    selected[1] = variant.option2;
    selected[2] = variant.option3;
    return selected;
  }

  function findBestVariant(variants, baseOptions, changedIndex, changedValue) {
    const selected = baseOptions.slice();
    selected[changedIndex] = changedValue;
    const optionKey = 'option' + (changedIndex + 1);
    let variant = null;

    variant = variants.find(function (item) {
      return item.available && optionsMatchVariant(selected, item);
    });

    if (!variant) {
      variant = variants.find(function (item) {
        return item.available && item[optionKey] === changedValue;
      });
    }

    if (!variant) {
      variant = variants.find(function (item) {
        return optionsMatchVariant(selected, item);
      });
    }

    if (!variant) {
      variant = variants.find(function (item) {
        return item[optionKey] === changedValue;
      });
    }

    syncSelectedWithVariant(selected, variant);
    return { variant: variant, selected: selected };
  }

  function isOptionValueAvailable(variants, optionIndex, value) {
    const optionKey = 'option' + (optionIndex + 1);
    return variants.some(function (variant) {
      return variant.available && variant[optionKey] === value;
    });
  }

  function updateSwatchVariantData(card, variants) {
    const baseOptions = getSelectedOptions(card);

    card.querySelectorAll('[data-mt-card-option]').forEach(function (btn) {
      const optionIndex = parseInt(btn.dataset.optionIndex, 10);
      const value = btn.dataset.optionValue;
      const match = findBestVariant(variants, baseOptions, optionIndex, value);

      if (!match.variant) return;

      btn.dataset.variantId = String(match.variant.id);
      btn.dataset.variantPrice = String(match.variant.price);
      btn.dataset.variantComparePrice = String(match.variant.compare_at_price || 0);
    });
  }

  function updateCardPrice(card, variant, section) {
    const currentWrap = card.querySelector('[data-mt-card-price-current]');
    const compareWrap = card.querySelector('[data-mt-card-price-compare]');

    if (!currentWrap || !variant) return;

    setMoneyContent(currentWrap, variant.price);

    if (compareWrap) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        setMoneyContent(compareWrap, variant.compare_at_price);
        compareWrap.hidden = false;
      } else {
        compareWrap.hidden = true;
      }
    }

    window.setTimeout(function () {
      refreshEtransMoney(section);
    }, 20);
  }

  function updateCardImage(card, swatch, variant) {
    const media = card.querySelector('[data-mt-card-media]');
    const defaultImg = card.querySelector('[data-mt-card-image-default]');
    const hoverImg = card.querySelector('[data-mt-card-image-hover]');

    if (swatch && swatch.dataset.cardImage) {
      const hoverSrc = swatch.dataset.cardHoverImage || '';
      setCardImage(defaultImg, swatch.dataset.cardImage);

      if (hoverImg && hoverSrc) {
        setCardImage(hoverImg, hoverSrc);
        if (media) media.classList.add('mt-collection-filters__card-media--has-hover');
      } else if (hoverImg) {
        hoverImg.removeAttribute('src');
        if (media) media.classList.remove('mt-collection-filters__card-media--has-hover');
      }
      return;
    }

    if (variant && variant.featured_image && variant.featured_image.src) {
      setCardImage(defaultImg, variant.featured_image.src);
      if (hoverImg) {
        hoverImg.removeAttribute('src');
        if (media) media.classList.remove('mt-collection-filters__card-media--has-hover');
      }
    }
  }

  function updateOptionAvailability(card, variants) {
    const selected = getSelectedOptions(card);

    card.querySelectorAll('[data-mt-card-option]').forEach(function (btn) {
      const optionIndex = parseInt(btn.dataset.optionIndex, 10);
      const value = btn.dataset.optionValue;
      const isAvailable = isOptionValueAvailable(variants, optionIndex, value);
      const isActive = selected[optionIndex] === value;

      btn.classList.toggle('is-disabled', !isAvailable);
      btn.classList.toggle('is-active', isActive);
      btn.disabled = !isAvailable;
      btn.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function applyOptionToCard(card, swatch, section) {
    const optionIndex = parseInt(swatch.dataset.optionIndex, 10);
    const value = swatch.dataset.optionValue;
    const variants = getCardVariants(card);
    const result = findBestVariant(variants, getSelectedOptions(card), optionIndex, value);

    if (!result.variant) return;

    card.mtSelectedOptions = result.selected;
    updateOptionAvailability(card, variants);
    updateSwatchVariantData(card, variants);
    updateCardImage(card, swatch, result.variant);
    updateCardPrice(card, result.variant, section);
  }

  function initCard(card, section) {
    const variants = getCardVariants(card);
    if (!variants.length) return;

    card.mtSelectedOptions = null;
    const activeButtons = card.querySelectorAll('[data-mt-card-option].is-active');

    card.mtDefaultOptions = null;

    if (activeButtons.length) {
      const selected = getDefaultOptions(card).slice();
      activeButtons.forEach(function (btn) {
        const idx = parseInt(btn.dataset.optionIndex, 10);
        selected[idx] = btn.dataset.optionValue;
      });
      card.mtSelectedOptions = selected;
    } else {
      getSelectedOptions(card);
    }

    const selected = getSelectedOptions(card);
    updateOptionAvailability(card, variants);
    updateSwatchVariantData(card, variants);

    const variant = findVariant(variants, selected);
    if (variant) {
      updateCardPrice(card, variant, section);
    }
  }

  function isJudgeMeBadgeHidden(badge) {
    if (!badge) return true;
    if (badge.style.display === 'none') return true;
    var style = window.getComputedStyle(badge);
    return style.display === 'none' || style.visibility === 'hidden';
  }

  function cardRatingHasReviews(rating) {
    if (rating.querySelector('.mt-product-rating--shopify')) {
      return true;
    }

    var badge = rating.querySelector('.jdgm-preview-badge');
    if (!badge) {
      return false;
    }

    if (isJudgeMeBadgeHidden(badge)) {
      return false;
    }

    var reviewCount = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
    if (reviewCount > 0) {
      return true;
    }

    var averageRating = parseFloat(badge.getAttribute('data-average-rating') || '0');
    if (!isNaN(averageRating) && averageRating > 0) {
      return true;
    }

    return !!badge.querySelector('.jdgm-star');
  }

  function updateCardRatingVisibility(rating) {
    rating.classList.toggle('has-reviews', cardRatingHasReviews(rating));
  }

  function bindCardRating(card) {
    var rating = card.querySelector('[data-mt-card-rating]');
    if (!rating || rating.dataset.mtCardRatingBound === 'true') return;

    rating.dataset.mtCardRatingBound = 'true';
    updateCardRatingVisibility(rating);

    if (!rating.querySelector('.jdgm-preview-badge')) return;

    var observer = new MutationObserver(function () {
      updateCardRatingVisibility(rating);
    });
    observer.observe(rating, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'data-number-of-reviews', 'data-average-rating'],
    });

    [100, 300, 800, 1500, 3000, 5000, 8000].forEach(function (delay) {
      window.setTimeout(function () {
        updateCardRatingVisibility(rating);
      }, delay);
    });
  }

  function initCards(section) {
    section.querySelectorAll('[data-mt-collection-card]').forEach(function (card) {
      initCard(card, section);
      bindCardRating(card);
    });
  }

  function reinitSection(section) {
    if (!section) return;
    initCards(section);
    bindPriceRange(section);

    const sortSelect = section.querySelector('[data-mt-collection-sort]');
    if (sortSelect) {
      updateSortDisplay(sortSelect);
      updateMobileSortDisplay(section, sortSelect.options[sortSelect.selectedIndex].text.trim());
      syncMobileSortState(section, sortSelect.value);
    }
  }

  function bindCardSwatches(section) {
    if (!section) return;

    if (section.dataset.mtSwatchesBound !== 'true') {
      section.dataset.mtSwatchesBound = 'true';
      section.addEventListener('click', function (event) {
        const swatch = event.target.closest('[data-mt-card-option]');
        if (!swatch || !section.contains(swatch)) return;
        if (swatch.disabled || swatch.classList.contains('is-disabled')) return;

        event.preventDefault();
        event.stopPropagation();

        const card = swatch.closest('[data-mt-collection-card]');
        if (!card) return;

        applyOptionToCard(card, swatch, section);
      });
    }

    initCards(section);
  }

  function bindPriceRange(section) {
    if (!section) return;

    section.querySelectorAll('.js-price-range').forEach(function (parent) {
      if (parent.dataset.mtPriceBound === 'true') {
        if (typeof parent.mtRefreshPriceSlider === 'function') {
          parent.mtRefreshPriceSlider();
        }
        return;
      }

      const ranges = parent.querySelectorAll('input[type="range"]');
      const inputs = parent.querySelectorAll('input[type="number"]');
      if (ranges.length < 2 || inputs.length < 2) return;

      const rangeMin = ranges[0];
      const rangeMax = ranges[1];
      const inputMin = inputs[0];
      const inputMax = inputs[1];
      const sliderTrack = parent.querySelector('.mt-collection-filters__price-slider');
      const rangeLimit = parseFloat(rangeMax.max || inputMin.max || rangeMax.value || 0);

      parent.dataset.mtPriceBound = 'true';

      function hideNativeRangeTracks() {
        [rangeMin, rangeMax].forEach(function (el) {
          el.style.setProperty('accent-color', 'transparent');
          el.style.setProperty('background', 'transparent');
        });
      }

      function updateTrackFill() {
        if (!sliderTrack) return;

        const limit = rangeLimit > 0 ? rangeLimit : 1;
        let min = parseFloat(rangeMin.value);
        let max = parseFloat(rangeMax.value);

        if (!Number.isFinite(min)) min = 0;
        if (!Number.isFinite(max)) max = limit;
        if (min > max) {
          const swap = min;
          min = max;
          max = swap;
        }

        sliderTrack.style.setProperty('--price-min', String(min));
        sliderTrack.style.setProperty('--price-max', String(max));
        sliderTrack.style.setProperty('--price-limit', String(limit));
      }

      function markSliderReady() {
        if (!sliderTrack) return;
        hideNativeRangeTracks();
        updateTrackFill();
        sliderTrack.classList.add('is-ready');
      }

      function clampPair(minVal, maxVal) {
        let min = Number.isFinite(minVal) ? minVal : 0;
        let max = Number.isFinite(maxVal) ? maxVal : rangeLimit;
        if (min > max) {
          const swap = min;
          min = max;
          max = swap;
        }
        min = Math.max(0, min);
        max = Math.min(rangeLimit, max);
        return [min, max];
      }

      function applyValues(min, max) {
        rangeMin.value = String(min);
        rangeMax.value = String(max);
        inputMin.value = String(min);
        inputMax.value = String(max);
        updateTrackFill();
      }

      function syncFromSliders() {
        const pair = clampPair(parseFloat(rangeMin.value), parseFloat(rangeMax.value));
        applyValues(pair[0], pair[1]);
      }

      function syncFromInputs() {
        const pair = clampPair(parseFloat(inputMin.value), parseFloat(inputMax.value));
        applyValues(pair[0], pair[1]);
      }

      function scheduleTrackFill() {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(markSliderReady);
        });
      }

      parent.mtRefreshPriceSlider = markSliderReady;
      scheduleTrackFill();

      const priceAccordion = parent.closest('details');
      if (priceAccordion) {
        priceAccordion.addEventListener('toggle', function () {
          if (priceAccordion.open) scheduleTrackFill();
        });
      }

      if (typeof ResizeObserver !== 'undefined' && sliderTrack) {
        let resizeFrame = null;
        const resizeObserver = new ResizeObserver(function () {
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(function () {
            resizeFrame = null;
            markSliderReady();
          });
        });
        resizeObserver.observe(sliderTrack);
      } else {
        window.addEventListener('resize', scheduleTrackFill);
      }

      function submitPriceFilter() {
        if (typeof theme === 'undefined' || !theme.CollectionFilters) return;
        const form = inputMin.closest('form');
        if (!form) return;

        window.clearTimeout(parent.mtPriceSubmitTimer);
        parent.mtPriceSubmitTimer = window.setTimeout(function () {
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData).toString();
          theme.CollectionFilters.renderPage(searchParams, section);
        }, 600);
      }

      rangeMin.addEventListener('input', function () {
        markSliderReady();
        syncFromSliders();
      });
      rangeMax.addEventListener('input', function () {
        markSliderReady();
        syncFromSliders();
      });
      inputMin.addEventListener('input', syncFromInputs);
      inputMax.addEventListener('input', syncFromInputs);

      rangeMin.addEventListener('change', submitPriceFilter);
      rangeMax.addEventListener('change', submitPriceFilter);
      inputMin.addEventListener('change', submitPriceFilter);
      inputMax.addEventListener('change', submitPriceFilter);
    });
  }

  function initSection(section) {
    if (!section) return;
    bindSort(section);
    bindMobileControls(section);
    bindActiveFilters(section);
    bindCardSwatches(section);
    bindPriceRange(section);
  }

  function initAll() {
    document.querySelectorAll('[data-mt-collection-filters]').forEach(initSection);
  }

  function afterGridUpdate() {
    window.setTimeout(function () {
      document.querySelectorAll('[data-mt-collection-filters]').forEach(reinitSection);
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.matches('[data-mt-collection-filters]')) {
      initSection(event.target);
    }
  });

  if (typeof theme !== 'undefined' && theme.CollectionFilters) {
    const originalRenderFilters = theme.CollectionFilters.renderFilters;
    theme.CollectionFilters.renderFilters = function (container) {
      originalRenderFilters.call(this, container);
      const section = getSection(container) || container;
      if (section && section.matches('[data-mt-collection-filters]')) {
        bindPriceRange(section);
        afterGridUpdate();
      }
    };

    if (theme.CollectionFilters.renderProductGrid) {
      const originalRenderProductGrid = theme.CollectionFilters.renderProductGrid;
      theme.CollectionFilters.renderProductGrid = function (html) {
        originalRenderProductGrid.call(this, html);
        afterGridUpdate();
      };
    }
  }
})();
